import DownloadIcon from "@mui/icons-material/Download";
import {
    Box,
    Button,
    CircularProgress,
    Paper,
    TextField,
    Typography
} from '@mui/material';
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import dayjs from 'dayjs';
import 'dayjs/locale/it';
import { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { useNavigate, useParams } from "react-router-dom";
import MDButton from "../../components/MDButton";
import DashboardLayout from "../../examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "../../examples/Navbars/DashboardNavbar";
import apiService from "../../services/api-service";

let filesContent;

const SteelWithdrawalReportAdd = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [document, setDocument] = useState({
    url: null,
    file: null,
    report_number: '',
    date: null
  });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'info' });
  const [fieldErrors, setFieldErrors] = useState({
    file: false,
    report_number: false,
    date: false
  });

  const handleSetNotification = (msg, severityType) => {
    if (severityType === 'success') {
      toast.success(msg, {id: 'steel-withdrawal-report-add-toast'});
    } else {
      toast.error(msg, {id: 'steel-withdrawal-report-add-toast'});
    }
  };

  useEffect(() => {
    if (id) {
      fetchDocument(id);
    }
  }, [id]);

  const fetchDocument = async (docId) => {
    setLoading(true);
     apiService.get("/steel-withdrawal-report-managment/",{id_document: id} ,{} )
      .then((response) => {
        if (response)
          setDocument(response)
      })
      .catch((error) => {
        handleSetNotification('Errore durante la chiamata al server, codice d\'errore #08514262429906', 'error');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleFileChange = (event) => {
    if (!event.target.files) return;

    const filePromise = new Promise((resolve) => {
      const reader = new FileReader();
      reader.onloadend = () => {
        const fileObj = {
          name: event.target.files[0].name,
          type: event.target.files[0].type,
          size: event.target.files[0].size,
          modified: event.target.files[0].lastModified,
          content: null
        };
        const contentObj = reader.result;

        filesContent = contentObj;

        resolve(fileObj);
      };
      reader.readAsDataURL(event.target.files[0]);
    });

    Promise.resolve(filePromise).then((processedFile) => {
      setDocument((prevDoc) => ({ ...prevDoc, file: processedFile, url: null }));
      setFieldErrors((prevErrors) => ({ ...prevErrors, file: false }));
    });
  };

  const handleInputChange = (name, value) => {
    setDocument((prevDoc) => ({ ...prevDoc, [name]: value }));
    setFieldErrors((prevErrors) => ({ ...prevErrors, [name]: false }));
  };

  const handleSave = async () => {
    const errors = {
      file: !document.file && !document.url,
      report_number: !document.report_number,
      date: !document.date
    };

    setFieldErrors(errors);

    if (Object.values(errors).some(Boolean)) {
      handleSetNotification('Per salvare il verbale devi inserire tutti i campi', 'error');
      return;
    }

    setLoading(true);
    let documentToSave = JSON.parse(JSON.stringify(document));
    if (document.file) {
      documentToSave.file.content = filesContent;
    }
    console.log(documentToSave);
    let data = null
    if (id) {
      data = {area_id: localStorage.getItem("areaSelected"), document: documentToSave, id: id}
    }else{
      data = {area_id: localStorage.getItem("areaSelected"), document: documentToSave}
    }
    apiService.post("/steel-withdrawal-report-managment/", {},data )
      .then((response) => {
        handleSetNotification('Verbale salvato con successo', 'success');
        navigate("/steel-withdrawal-report-managment/");
      })
      .catch((error) => {
        handleSetNotification('Errore durante la chiamata al server, codice d\'errore #08514262429906', 'error');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleDownload = () => {
    if (document.url) {
      window.open(document.url, '_blank');
    }
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="it">
        {!loading ?
          <>
            <center>
              <MDButton onClick={() => navigate("/steel-withdrawal-report-managment/")}>Torna alla tabella</MDButton>
            </center>
          <Paper elevation={3} sx={{p: 3, maxWidth: 500, mx: 'auto', mt: 4}}>
            <Typography variant="h5" gutterBottom>
              {id ? 'Modifica il verbale' : 'Aggiungi un verbale'}
            </Typography>
            <Box component="form" noValidate autoComplete="off" sx={{mt: 2}}>
              <Box sx={{mb: 2}}>
                <input
                  accept="*/*"
                  style={{display: 'none'}}
                  id="raised-button-file"
                  type="file"
                  onChange={handleFileChange}
                />
                <label htmlFor="raised-button-file">
                  <Button
                    variant="contained"
                    component="span"
                    sx={{
                      color: 'white!important',
                      borderColor: fieldErrors.file ? 'red' : 'primary.main',
                      '&:hover': {
                        borderColor: fieldErrors.file ? 'red' : 'primary.dark',
                      },
                    }}
                  >
                    {document.file || document.url ? 'Cambia file' : 'Carica file'}
                  </Button>
                </label>
                {(document.file || document.url) && (
                  <Typography variant="body2" sx={{mt: 1}}>
                    {document.file ? document.file.name : 'File già caricato'}
                  </Typography>
                )}
                {(id && document.file) || document.url ? (
                  <Button
                    startIcon={<DownloadIcon/>}
                    variant="contained"
                    color="primary"
                    sx={{
                      marginBottom: "30px",
                      color: 'white!important',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      gap: '8px'
                    }} onClick={handleDownload}
                  >
                    Scarica
                  </Button>
                ) : null}
                {fieldErrors.file && (
                  <Typography color="error" variant="caption" sx={{mt: 1, display: 'block'}}>
                    File is required
                  </Typography>
                )}
              </Box>

              <TextField
                fullWidth
                label="Numero Verbale"
                name="report_number"
                value={document.report_number}
                onChange={(e) => handleInputChange('report_number', e.target.value)}
                sx={{mb: 2}}
                required
                error={fieldErrors.report_number}
                helperText={fieldErrors.report_number ? 'Numero Verbale è richiesto' : ''}
              />

              <DatePicker
                label="Data *"
                value={document.date ? dayjs(document.date) : null}
                sx={{color: fieldErrors.date ? 'red' : 'inherit', borderColor: fieldErrors.date ? 'red' : 'inherit'}}
                onChange={(newValue) => {
                  const formattedDate = newValue ? dayjs(newValue).format('YYYY-MM-DD') : null;
                  handleInputChange('date', formattedDate);
                }}
                renderInput={(params) => (
                  <TextField
                    {...params}
                    fullWidth
                    name="date"
                    sx={{mb: 2}}
                    required
                    error={fieldErrors.date}
                    helperText={fieldErrors.date ? 'Data richiesta' : ''}
                  />
                )}
                inputFormat="DD-MM-YYYY"
              />

              <Box sx={{display: 'flex', justifyContent: 'space-between', mt: 2,}}>
                <Button sx={{color: 'white!important'}} variant="contained" onClick={handleSave} disabled={loading}>
                  Salva
                </Button>
              </Box>
            </Box>
            {error && (
              <Typography color="error" sx={{mt: 2}}>
                {error}
              </Typography>
            )}
          </Paper>
          </>
          :
          <center>
            <CircularProgress size={120} sx={{marginTop: "250px", color: "#2b84ea"}}/>
          </center>
        }
      </LocalizationProvider>
    </DashboardLayout>

  );
};

export default SteelWithdrawalReportAdd;